import i18n from "src/i18n/i18n";
import * as Yup from "yup";

export default class InvoiceExpeditor {
    id: number;
    rfc: string;
    name: string;
    postal_code: string;
    tax_regime: string;
    street: string;
    suburb: string;
    city: string;
    state: string;
    country: string;
    expedition_place: string;
    logo_type: number;
    logo: File;
    created_at: string;
    updated_at: string;

    static getRules(invoiceExpeditor: InvoiceExpeditor) {
        return Yup.object().shape({
            rfc: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .min(12)
                .max(13)
                .matches(/^([A-Z]{3,4})(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))([A-Z\d]{2}(?:[A\d]))?$/, "RFC no válido"),
            name: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .max(200),
            postal_code: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .min(5)
                .max(5),
            tax_regime: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .min(3)
                .max(3),
            street: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .max(150),
            suburb: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .max(150),
            city: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .max(150),
            state: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .max(100),
            country: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .max(100),
            expedition_place: Yup.string()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .max(150),
            logo: Yup.mixed(),
            logo_type: Yup.number()
                .required(i18n.t("VALIDATION.REQUIRED"))
                .min(0)
                .max(1),
        })
    }

    static getInitValues(invoiceExpeditor: InvoiceExpeditor) {
        return {
            rfc: invoiceExpeditor ? invoiceExpeditor.rfc : "",
            name: invoiceExpeditor ? invoiceExpeditor.name : "",
            postal_code: invoiceExpeditor ? invoiceExpeditor.postal_code : "",
            tax_regime: invoiceExpeditor ? invoiceExpeditor.tax_regime : "",
            street: invoiceExpeditor ? invoiceExpeditor.street : "",
            suburb: invoiceExpeditor ? invoiceExpeditor.suburb : "",
            city: invoiceExpeditor ? invoiceExpeditor.city : "",
            state: invoiceExpeditor ? invoiceExpeditor.state : "",
            country: invoiceExpeditor ? invoiceExpeditor.country : "",
            expedition_place: invoiceExpeditor ? invoiceExpeditor.expedition_place : "",
            logo: "",
            logo_type: invoiceExpeditor ? invoiceExpeditor.logo_type : "",
        }
    }
}
